export default __webpack_public_path__ + "35d57320d9df28ec0d0d8bd1b5c75983.png";